<template>
  <div class="qna-list-wrapper">
    <Alert type="warning" style="margin: 0px 20px;" v-if="!webcast.qnaShowQuestions" show-icon>{{$t('hide_questions')}}</Alert>
    <ul id="qna-list" class="qna-list" v-if="qnaItems.length && webcast.qnaShowQuestions">
      <li class="qna-item" v-for="qna in qnaItems">
        <!-- qna-header -->
        <div class="qna-item-header">
          <!-- qna-person-info -->
          <div class="qna-item-person">
            <span class="qna-item-person-name">{{ qna.name }} </span>
            <span class="qna-item-person-location">{{ qna.location }}</span>
          </div>

          <div class="qna-item-created" style="font-size:12px;">
            <span>{{ qna.createdAt | moment('HH:mm') }}</span>
          </div>
        </div>

        <!-- .qna-body -->
        <div class="qna-item-body">
          {{ qna.text }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import {
  mapState,
  mapGetters,
  mapActions
} from 'vuex'
import moment from 'moment'

export default {
  computed: {
    ...mapGetters('qna', {
      findQuestionsInStore: 'find',
    }),
    ...mapGetters('webcast', {
      webcast: 'getCopy',
    }),
    qnaItems () {
      
      return this.findQuestionsInStore({
        query: {
          webcastId: this.webcast._id,
          isApproved: true,
          bucket: 'inbox',
          $limit: 1000
        }
      }).data
    },
  },
  watch:{
    qnaItems(){
      this.scrollToListBottom();
    }
  },
  methods: {
    ...mapActions('qna', {
      questionList: 'find',
    }),
    scrollToListBottom () {
      let containerEl = document.getElementsByClassName('qna-list-wrapper')[0];
      let listEl = document.getElementsByClassName('qna-list')[0];

      if (listEl) {
        //containerEl.scrollTop = listEl.scrollHeight;
        listEl.scrollTop = listEl.scrollHeight;
      }
    },
  },
  created () {
    this.questionList({query:{
      webcastId: this.webcast._id
    }}).then((response) => {
      this.scrollToListBottom();
    });
  }
}
</script>

<style lang="scss" scoped>
  .qna-list-wrapper{
		overflow: auto;
    height: 100%;
    width: 100%;
		padding-top: 20px;
		padding-bottom: 115px;
		//height: calc(100vh - (86px + 52px + 100px));

		textarea.ivu-input{
			height: 1em !important;
		}
	}

  .qna {
		&-list {
      font-size: 14px;
      overflow-y: scroll;
      height: 100%;
			list-style: none;
      .qna-item{
        margin-left: 15px;
				margin-right: 15px;
				&:not(:last-of-type) {
					margin-bottom: 15px;
				}
        &-header {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          align-items: center;
          .qna-item-person{
             &-name {
              color: #367DB8;
              &--action {
                font-size: 14px;
                font-weight: bold;
                color: #373C46;
              }
            }

            &-location {
              color: #808695;
              &--action {
                font-size: 14px;
                color: #777777;
              }
            }
          }
        }
      }
		}
  }
</style>
